import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_HORIZONTAL_SIGNING } from "../../../../../common/constants/modules"

import { horizontalSigningQueryKeys } from "./queryKeys"
import { useHorizontalSigningQuery } from "./useHorizontalSigningQueries"


export function useHorizontalSigningCategoriesStats(parameters = {}, config = {}) {
    const url = "horizontal_signs/stats/horizontal_sign_types/"

    const {
        filterBySubnetworks = true,
        ...otherConfig
    } = config

    const extendedQueryParameters = useExtendWithSubnetworks(parameters, API_MODULE_HORIZONTAL_SIGNING)
    const parametersToUse = filterBySubnetworks ? extendedQueryParameters : parameters

    const queryKey = horizontalSigningQueryKeys["stats_categories"](parametersToUse)

    return useHorizontalSigningQuery(
        url,
        queryKey,
        parametersToUse,
        otherConfig,
    )
}